<script lang="ts">
  import { BulletPoint } from '../../components/index';
  import { getHref } from '../../helpers/sections-helper';
  import './css/hero2.scss';
  import type { Hero } from '../types';
  import PricingTag from './_PricingTag.svelte';

  export let properties: Hero;

  $: ({
    callouts,
    button,
    headline,
    subHeadline,
    description,
    image,
    caption,
    pricingTag,
    buttonIcon,
  } = properties);
</script>

<section class="hero3">
  <div class="hero-img">
    <img src={image?.value} alt="hero-img" />
  </div>
  <div class="wrapper">
    <div class="hero-content">
      <div>
        {#if pricingTag?.content?.active}
          <PricingTag {pricingTag} />
        {/if}
        <h1 class="h1">{@html headline.value}</h1>
        <h2 class="h2">{@html subHeadline.value}</h2>
        <p class="sub-text">
          {@html description.value}
        </p>
      </div>
      <div class="benefits-list">
        {#each callouts.value as text}
          <div class="benefit">
            <BulletPoint bulletIcon={callouts.icon} />
            <p class="text">
              {@html text}
            </p>
          </div>
        {/each}
      </div>
      {#if button?.active}
        <div class="hero-bottom">
          <a
            id="hero2-book-now"
            target={button.link_type === 'External' ? '_blank' : ''}
            class="primary-button open-form-js flex items-center justify-center gap-2 !py-[8px]"
            href={getHref(button.link_type, button.link)}
          >
            {#if buttonIcon?.active}
              <span class="-mt-0.5"
                ><BulletPoint bulletIcon={buttonIcon?.value} /></span
              >
            {/if}
            {@html button.label}
          </a>
          {#if caption?.value}
            <a class="hero-stars-and-reviews" href="#testimonial">
              <p>{@html caption.value}</p>
            </a>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</section>
